/*
 *  Copyright (c) McAfee Inc.  All Rights Reserved.
 *
 * Primary entry point for executing the Analytics Engine
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { GetEngineSetting , getSystemPlugin , CreateRegistryStore, isoDateToDate, dateToMfeString, getGeoInfo } from "./common";
import { logNormal, logInformation, logWarning, logError, logDebug, logConsole, logRawTrack, logTransports, logAutomationError } from "./bootstrap_web_ext";
import { ModuleManager , globalEngine, enableAnalyticsSDKForUWP} from "./Init";
import { getMessageBus , GetProperty , bootstrapFileVersion, LoadScript , enableWebPack } from "./bootstrap_web_ext"

// #ENDIF WebPack
// Load common functions
LoadScript("common.js");

//Load Init Variables
LoadScript("Init.js");

var engine =
{
    // Registry hive for storing\retreivng data
    "defaultClientAnalyticsRegistry": GetEngineSetting("Analytics.Base.RegKey", "HKLM\\SOFTWARE\\McAfee\\McClientAnalytics"),
    "heartbeatTimestampKey" : "analytics_content_heartbeat_timestamp",
    "datasetsRefreshRate": 60 * 60 * 1000, // 1 hour
    // Place holder for the user id (client identifier)
    "userId": null,
    /* this is a helper function to assist in creating new events within the content scripts itself
    * PARAMS:
    *       uniqueId: event's unique identifier
    *       attributes: JSON object of key-value pairs describing the event
    * RETURN: JSON object to be sent to using the event_handler
    */
    "createEventJson": function(uniqueId, attributes)
    {
        try
        {
            attributes["Tracker.Type"] = "event";
            return {
                "UniqueIdentifier": uniqueId,
                "type": "event",
                "payload": attributes
            };
        }
        catch (e)
        {
            logError('engine::createEventJson: Exception caught with message: ' + e.message);
            return {};
        }
    },
    /* Translates profId to clsid
    * PARAMS:
    *   ProgId: target progId
    * RETURN: associated clsid if exists, null otherwise
    */
    "clsidFromProgId": function (ProgId)
    {
        try
        {
            var regPath = "HKCR\\" + ProgId + '\\CLSID';
            var registry = ModuleManager.getSingleton("registry");
            registry.openKey(regPath);
            return registry.queryValue('');
        }
        catch (e)
        {
            logError('engine.clsidFromString: ProgId(' + ProgId + '). Error msg:' + e.message);
            return null;
        }
    },
    /* Returns a dictionary that describe the context information (userId, appVersion, sdkVer)
    */
    "getDefaultDictionary": function()
    {
		var geoInfo = getGeoInfo();
		var geoid = geoInfo.geoid;
		var isQA = geoInfo.isQA;

        return {
            "Application.Name": this.getApplicationName(),
            "Hit.UserID": this.getContextId(),
            "Analytics.Content.Version": this.getContentVersion(),
            "Analytics.bootstrapFileVersion": this.getBootstrapFileVersion(),
            "device.geo.id": geoid,
            "device.env.qa": isQA,
            "analytics.sdk.version":this.getSDKVersionFromBuildSystem(),
            "product_analytics_dataitems_intest": this.getInTestAttributes()
        };
    },
    "getInTestAttributes": function()
    {
        try
        {
            var targetItems = [
                "device_videocontroller_name",
                "device_videocontroller_caption",
                "device_videocontroller_description",
                "device_videocontroller_videoprocessor",
                "device_videocontroller_deviceid",
                "device_videocontroller_adapterdactype",
                "device_videocontroller_adapterram",
                "device_videocontroller_driverversion",
                "device_videocontroller_maxrefreshrate",
                "device_videocontroller_minrefreshrate",
                "device_videocontroller_currentrefreshrate",
                "device_os_uwp_sideload_enabled"
            ];

            var result = {};
            var data_collector = ModuleManager.getSingleton("data_collector");

            for (var key in targetItems)
            {
                result[targetItems[key]] = data_collector.get(targetItems[key]);
            }
            return JSON.stringify(result);

        }
        catch(e)
        {
            logError('getInTestAttributes: ' + e.message);

        }
        return "{}";
    },
    "getApplicationName": function()
    {
        return 'Analytics.Content';
    },
    "getSDKVersionFromBuildSystem":function(){
        try
        {
            var versionInfo = GetProperty("Analytics.SDK.Version",""/*default*/);

            return versionInfo.replace(/,/gi,'.'); //replace ',' with '.'
        }catch(e){
            logError("getSDKVersionFromBuildSystem: "+e.message);
            return null;
        }
    },
    /*Returns the content version created by CBRMS
    */
    "getContentVersion": function()
    {
        try
        {
            // This variable will get created during the build step
            if (!engine_fileVersion)
            {
                logWarning("Failed to read version information.");
                return "1.0.0"; // assume the original content
            }
            return engine_fileVersion;
        }
        catch (e)
        {
            logWarning("Failed to read version information. Exception is '" + e.message + "'");
            return "1.0.0"; // assume the original content
        }
    },
    /*Returns the bootstrap version, which is also the SDK version (unless the bootstrap is manually loaded)
    */
    "getBootstrapFileVersion": function()
    {
        try
        {
            return bootstrapFileVersion;// This variable is defined in ca_bootstrap.js
        }
        catch(e)
        {
            // do nothing
            return null;
        }
    },
    "aleStaticInegration": function ()
    {
        var data_collector = ModuleManager.getSingleton("data_collector");
        return data_collector.get("product_analytics_integration_type_static");
    },
    /*Returns the user id (client id) if stored, creates it otherwise
    */
    "getContextId": function ()
    {
        try
        {

			 // step1: check if we already loaded the value
            if (this.userId && this.userId != "[unknown]")
            {
                return this.userId;
            }


            //step 1.1: getting value from uwp_storage for uwp events
            if (enableAnalyticsSDKForUWP) {
                var uwp_storage = ModuleManager.getSingleton("uwp_storage");
                this.userId = uwp_storage.get("device_uwp_mcafee_id");
                return this.userId;
            }

            // step2: if not loaded, check if stored in registry
            var data_collector = ModuleManager.getSingleton("data_collector");
            this.userId = data_collector.get("Hit.UserID");

            if (this.userId)
            {
                return this.userId;
            }

            //Reaching this line means that we have not created the user id
            //step3: create user id by hashing mircrosoft machine guid
            
            // The Microsoft Machine Guid must have been collected first
            var microsoftMachineGuid = data_collector.get("Device.Microsoft.Machine.Guid");
            var isUsingMicrosoftMachineGuid = false;

            if (microsoftMachineGuid && microsoftMachineGuid != '[ruleMismatch]')
            {
                try
                {
                    var hasher = ModuleManager.getSingleton("hash128");

                    var hash = hasher.hash128(microsoftMachineGuid);
                    this.userId = this._makeGuidFromHash(hash);
                    isUsingMicrosoftMachineGuid = true;
                    logNormal('microsoftMachineGuid was hashed to create uid: ' + this.userId);
                }
                catch (e)
                {
                    logError('An error was caught when hashing microsoftMachineGuid: ' + e.message);
                }
            }
            else
            {
                // technically we should never reach this
                logWarning('Machine Guid is missing');
            }

            if (!this.userId)
            {
                // If we failed hashing the machine guid, or if it didn't exist, create a new GUID using the system plugin
                logWarning('Failed to hash microsoftMachineGuid. Going to create a guid.')
                this.userId = getSystemPlugin().CreateGUID();
            }

            //step 4: store value in registry
            //If we can't store the User ID, we will get stuck in a loop when we send another event
            var registry = ModuleManager.getSingleton("registry");
            if(!registry.openKey(this.defaultClientAnalyticsRegistry, true))
            {
                logError("Could not open registry " + this.defaultClientAnalyticsRegistry);
                return this.userId;
            }

            if (!registry.setValue("Analytics.ContextId", this.userId, true))
            {
                logError("Could not save Analytics.ContextId");
                return this.userId;
            }
            
            //step5: send analytics event
            // Only send the event if value was stored fine
            var eventLabel = (isUsingMicrosoftMachineGuid ? 'Hashed microsoft machine guid' : 'Created a new GUID');
            this._sendNewUserCreatedEvent(eventLabel);
			
			try
			{
				if (this._shouldExpiryHackBeApplied())
				{
					this._hackToFixExpiryDate();
                    var data_collector = ModuleManager.getSingleton("data_collector");
                    data_collector.markDataExpired(["WSS.Expiry.Date", "WSS.Extended.Expiry.Date", "WSS.Install.Date", "WSS.Eula.Accepted.Date"]);
				}
			}
			catch(e)
			{
				logError("Eula Date hack threw " + e.message);
			}
            
            return this.userId;
        }
        catch (e)
        {
            logError('engine:getContextId: ' + e.message);
        }
    },
	"_hackToFixExpiryDate": function()
	{
        var timeNow = new Date();
        var mfeTimeNow = dateToMfeString(timeNow);
        var registryPlugin = ModuleManager.getSingleton("registry");

        if (registryPlugin.openKey("HKLM\\Software\\McAfee\\MSC\\AppInfo\\Substitute\\QueryParams", true))
        {
            logNormal('Writing EulaDt as ' + mfeTimeNow);
            registryPlugin.setValue("EulaDt", mfeTimeNow);
        }


        var expiryDate_epoch = timeNow.getTime() + 30*24*60*60*1000;
        expiryDate = new Date(expiryDate_epoch);

        var mfeExpiryDate = dateToMfeString(expiryDate);

        var data_collector = ModuleManager.getSingleton("data_collector");
        var appList_str = data_collector.get("WSS.Subdb.Applist");
        var appid_list = JSON.parse(appList_str);
        var appids = appid_list.join(';') + ';';

        var appcodes_list = [];
        var appNames_list = [];
        for (var idx in appid_list)
        {
            var appid = appid_list[idx];
            var registryHive = "HKLM\\SOFTWARE\\McAfee\\MSC\\SubManager\\Cache\\" + appid;
            var app_code = "";
            var app_name = "";
            try
            {
                if (registryPlugin.openKey(registryHive, false))
                {
                     app_code = registryPlugin.queryValue('app_code', true);
                     app_name = registryPlugin.queryValue('app_name', true);

                     app_code = (app_code == null) ? "" :app_code;
                     app_name = (app_name == null) ? "" :app_name;
                }
            }
            catch(e)
            {
                logError('Exception thrown when querying from: ' + registryHive);
            }
            appcodes_list.push(app_code);
            appNames_list.push(app_name);
        
        }
        var appcodes = appcodes_list.join(';') + ';';
        var appNames = appNames_list.join(';') + ';';

        var subMgr = getPluginFactory().CreateFromGuid("{9BE8D7B2-329C-442A-A4AC-ABA9D7572602}");
        if(!subMgr)
        {
            logError('Failed to create subMgr');
            return;
        }
        var attributes = {
            'installed': mfeTimeNow,
            'settings': mfeExpiryDate,
            'extended_expiry_dt': mfeExpiryDate
        };
        var bstrAttrList = '';
        for (var key in attributes)
        {
            bstrAttrList += key + '=' + attributes[key] + ';'
        }
        

        logNormal('Calling subMgr.UpdatePackageInfo with params appcodes('+appcodes+'). appids(' + appids + '). appNames(' + appNames + '). bstrAttrList('+bstrAttrList + ')');
        var updateRes = subMgr.UpdatePackageInfo('', '', appcodes, appids, appNames, bstrAttrList);
        logNormal('subMgr.UpdatePackageInfo result: ' + updateRes);

	},
	"_shouldExpiryHackBeApplied": function()
	{
		try
		{
			logNormal("starting Execution of _hackToFixExpiryDate");
			var data_collector = ModuleManager.getSingleton("data_collector");

			// only run this for factory builds
			if("1" != data_collector.get("WSS.isFactory"))
			{
				logNormal("Not applying hack, WSS.isFactory is 1");
				return false;
			}

            if("[not assigned]" !=  data_collector.get("WSS.Product.Key"))
            {
                logNormal("Not applying hack, WSS.Product.Key is assigned");
                return false;
            }

			// only run this if there isn't a eula date
			var eulaDate = data_collector.get("WSS.Eula.Accepted.Date.ISO")
			if("[not assigned]" != eulaDate)
			{
				logNormal("Not applying hack, eula date is " + eulaDate);
				return false;
			}

			var expiryDate = data_collector.get("WSS.Expiry.Date");

			var operations = ModuleManager.getSingleton("operations");
			var daysSinceExpiry = operations.timeSince(expiryDate,"days");
			if ( daysSinceExpiry < 0)
			{
				logConsole("Not applying hack, expiry isn't in the past: dayssinceexpiry=" + daysSinceExpiry);
				return false;
			}			
			
		}
		catch(e)
		{
			logError("_hackToFixExpiryDate threw: " + e.message);
			return false;
		}

		// we're in a bad state and should try to apply the workaround
		return true;
	
	},
	
	
    /*This function gets called by __clearAll function, it then notifies other classes about shutting down to store any data needed
    * __clearAll gets invoked by the ScriptHost on teardown
    *
    */
    "notifyHostTeardown": function ()
    {
        try 
        {
            // Script Host is Tearing Down. Notify Subscribers
            var analyticstransport = ModuleManager.getSingleton("transport");
            analyticstransport.notifyHostTeardown();
        }
        catch(e)
        {
            logError('engine::notifyHostTeardown: ' + e.message);
        }
    },
    /*Checks if automation mode is enabled
    * RETURN: true if enabled, false otherwise
    */
    "isAutomationModeEnabled": function()
    {
        try
        {
            var registry = ModuleManager.getSingleton("registry");
            registry.openKey(this.defaultClientAnalyticsRegistry);
            return (registry.queryValue('enableContentAutomation') == 1);
        }
        catch(e)
        {
            logError('Exception caught: ' + e.message);
            return false;
        }
    },
    /*This function will loop over a list of function that sets up the environment
    */
    "start": function ()
    {
        for (var funcIndex in this._startUpFunctions)
        {
            try
            {
                // Run step
                logInformation('engine::start: running function index: ' + funcIndex);
                this._startUpFunctions[funcIndex]();
            }
            catch(e)
            {
                logError('engine::start: Exception caught in step ('+ funcIndex + '): ' + e.message);
            }
        }
    },
    /* A list of functions that need to be run to properly setup the environment and load needed scripts
    */
    "_startUpFunctions": 
    [
        function()
        {
            globalEngine.RegistryStore = CreateRegistryStore(engine.defaultClientAnalyticsRegistry);
        },
        // New event handler
        function() //LoadEventHandler
        {
            ModuleManager.getSingleton("event_handler");
        },
        function() //StartObservationBasedAnalytics
        {
            try
            {
                if(engine.aleStaticInegration())
                {
                    logWarning('Not starting observation_analytics, since this is static ALE integration');
                    return;
                }

                var observation_analytics = ModuleManager.getSingleton("observation_analytics");
                observation_analytics.start();
            }
            catch (e)
            {
                logError('Failed to run StartObservationBasedAnalytics: ' + e.message);
            }
        },
        function() //SubscribeToAnalyticsEvents
        {
            //Subscribe for Analytics messages
            var msgbus = getMessageBus();

            // This is our first-chance to report whether the message bus is available, so...
            if (!msgbus.IsAvailable())
            {
                logWarning("Message Bus could not be loaded; subscriptions will not be active");
            }

            if(engine.isAutomationModeEnabled())
            {
                msgbus.Unsubscribe("Analytics.v1.AddRecord");
                msgbus.Unsubscribe("Analytics.AddRecord");
                msgbus.Subscribe("Analytics.Automation.AddRecord");    
            }
            else
            {
                msgbus.Subscribe("Analytics.v1.AddRecord");
            }
        },
        function() //WrapCleanAllFunction
        {
            try
            {
                var nativeCleanAll = globalEngine.__cleanAll;
                globalEngine.__cleanAll = function()
                {
                    // Notify Cleanup
                    engine.notifyHostTeardown();
                    nativeCleanAll.apply(this, arguments);
                };
            }
            catch(e)
            { }
        },
        function() //StoreHardwareAndSoftwareId
        {
            //Store hardware and software ids in registry
            var __mcUtil = ModuleManager.getSingleton("mcutil");
            if(__mcUtil) __mcUtil.storeHardwareAndSoftwareId();
        },
        function ()
        {
            logNormal('Calling engine.getContextId()');
            engine.getContextId();
        },
        function() //RecreateDataAggregator
        {
            //TODO: Add condition to check SDK version
            //Recreate DA after 5 seconds
            setTimeout(function(){globalEngine.getDaSender(true);} , 5 * 1000);
        },
        function() //configureContentHeartbeat
        {
            try
            {
                if(engine.aleStaticInegration())
                {
                    logWarning('Not setting up heartbeat since this is static ALE integration');
                    return;
                }

                var lastHeartbeatTimeStr = globalEngine.RegistryStore.get(engine.heartbeatTimestampKey);
                if (!lastHeartbeatTimeStr)
                {
                    logError("Could not retrieve last heartbeat timestamp. Calling `_runAnalyticsHeartbeat` in 5 seconds");
                    setTimeout(engine._runAnalyticsHeartbeat , 5000);
                    return;
                }

                var lastHeartbeatTime = isoDateToDate(lastHeartbeatTimeStr);
                var timeNow = new Date();

                var timeDiff = timeNow - lastHeartbeatTime;
                var msToNextHeartbeat = parseInt( (24 * 60 * 60 * 1000) - timeDiff, 10);

                logNormal('msToNextHeartbeat: ' + msToNextHeartbeat);
                if (isNaN(msToNextHeartbeat) || (msToNextHeartbeat < 0))
                {
                    msToNextHeartbeat = 5000;
                    logNormal('configureContentHeartbeat: Time to next heartbeat has passed or was not determined. Setting next heartbeat in 5 seconds');
                }
                logInformation('configureContentHeartbeat: msToNextHeartbeat (' + msToNextHeartbeat + '). lastHeartbeatTime(' + lastHeartbeatTimeStr + ')');
                //Set content heartbeat to be triggered after the
                setTimeout(engine._runAnalyticsHeartbeat , msToNextHeartbeat);
            }
            catch(e)
            {
                logError('configureContentHeartbeat: ' + e.message);
            }
        }
    ],
    /////////////////////////////////////////////////////////
    // PRIVATE FUNCTIONS

    "_makeGuidFromHash": function (hashStr)
    {
        if (32 != hashStr.length)
        {
            logError('Hashed string passed does not match required length(32). Value: ' + hashStr);
            return null;
        }

        var uid = '';
        try
        {
            var data1 = hashStr.substr(0, 8);
            var data2 = hashStr.substr(8, 4);
            var data3 = hashStr.substr(12, 4);
            var data4 = hashStr.substr(16, 4);
            var data5 = hashStr.substr(20, 12);

            uid = '{' + data1 + '-' + data2 + '-' + data3 + '-' + data4 + '-' + data5 + '}';
            uid = uid.toUpperCase();
        }
        catch (e)
        {
            logError('Error retrieving guid from: ' + hashStr + '. Message: ' + e.message);
            return null;
        }
        return uid;
    },
    "_sendNewUserCreatedEvent": function (eventLabel)
    {
        try
        {
            if(engine.aleStaticInegration())
            {
                logWarning('Not sending analytics_new_user_created, since this is static ALE integration');
                return;
            }

            var record = this.createEventJson('analytics_new_user_created', {
                    'Tracker.Type': 'event',
                    'Event.Category': 'Analytics.Content',
                    'Sub.Category': 'LifeCycle',
                    'Event.Action': 'ClientId.Created',
                    'Event.Label': eventLabel
            });

            logNormal('Sending analytics_new_user_created event');
            var event_handler = ModuleManager.getSingleton("event_handler");
            event_handler.handleV1Record(record);
        }
        catch (e)
        {
            logError('_sendNewUserCreatedEvent: ' + e.message);
        }
    },
    "_runAnalyticsHeartbeat": function ()
    {
        //This is an internal Heartbeat to indicate that the user still have WSS installed
        //This event can also be used to determine the user coming as the first time the user sends this event
       
        try
        {
    
            var timestamp = new Date();
            var internalHeartbeat = engine.createEventJson('analytics_content_heartbeat', {
                'Tracker.Type': 'event',
                'Event.Category': 'Analytics.Content',
                'Event.Action': 'Analytics Heartbeat'
            });

            var event_handler = ModuleManager.getSingleton("event_handler");

            event_handler.handleV1Record(internalHeartbeat);
            // Triggering the verification after 24 hourts
            setTimeout(engine._runAnalyticsHeartbeat , (24 * 60 * 60 * 1000));

            globalEngine.RegistryStore.set(engine.heartbeatTimestampKey, timestamp.toISOString());
        }
        catch (e)
        {
            logError('engine::_runAnalyticsHeartbeat: ' + e.message);
        }
    }
}


function StartEngine()
{
    // Start engine and run startup steps
	try {
		logNormal("starting engine");
		engine.start();
	}
	catch (e) {
	}
}

if(typeof enableWebPack === "undefined")
{
    StartEngine();
}
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

export { engine, StartEngine};

// #ENDIF WebPack

